// 施工計画の正規化応答(ConstructionPlans + related.Works/Users/Groups)を、
// 従来のネスト形(constructionPlanRow: 施工計画→Work、施工計画→User)へ
// 復元する共通ハイドレータ。結合は nestHydrator の宣言的エンジン(生成メタデータのエッジキー)で行う。
// related.Works はサーバー側で alive のみ(従来 include の where deleted_at:null を
// 踏襲)のため、削除済みの参照先は従来どおり null になる。
// 工事(Work)は担当者を持たないため User ネストは無い。施工計画の User は preparer_user_id で結合する。
import { constructionPlanRow, NormalizedConstructionPlanResponse } from "../../schema/console/construction_plan";
import { belongsToOf, requiredUserOf } from "./nestHydrator";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateConstructionPlans(normalized: NormalizedConstructionPlanResponse): constructionPlanRow[] {
  const users = usersWithGroupOf(normalized.related.Users, normalized.related.Groups);
  const workOf = belongsToOf("ConstructionPlan.work_id", normalized.related.Works);
  const planUserOf = requiredUserOf("ConstructionPlan.preparer_user_id", users, "施工計画", "担当");
  return normalized.ConstructionPlans.map((constructionPlan): constructionPlanRow => ({
    ...constructionPlan,
    Work: workOf(constructionPlan),
    User: planUserOf(constructionPlan),
  }));
}
